module.exports = __webpack_public_path__ + "static/fonts/uni.6fcee940.woff";